export class PerfMonitor {
  private readonly marks = new Map<string, number>();
  private readonly measures = new Map<string, number>();

  mark(name: string): void {
    const now = performance.now();
    this.marks.set(name, now);
    performance.mark(name);
  }

  measure(name: string, startMark: string, endMark: string): number | undefined {
    const start = this.marks.get(startMark);
    const end = this.marks.get(endMark);
    if (start === undefined || end === undefined) return undefined;
    const duration = Math.max(0, end - start);
    this.measures.set(name, duration);
    try {
      performance.measure(name, startMark, endMark);
    } catch {
      // Duplicate browser performance entries are harmless for this dev-only panel.
    }
    return duration;
  }

  get(name: string): number | undefined {
    return this.measures.get(name);
  }

  entries(): ReadonlyMap<string, number> {
    return this.measures;
  }
}
